import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';

var openWechatPopup = function(redirectUrl, appId) {
    var height = 600;
    var width = 400;
    var top = window.innerHeight / 2 - height / 2;
    var left = window.innerWidth / 2 - width / 2;
    window.name = 'wwwagodacom';
    var popupUrl = new URL(redirectUrl);
    popupUrl.searchParams.append('id', appId);
    popupUrl.searchParams.append('sec_parent', window.location.origin);
    return window.open(popupUrl.toString(), '_blank', "height=" + height + ",width=" + width + ",menubar=0,status=0,top=" + top + ",left=" + left);
};
var WeChatSdkLogin = function(config) {
    return new Promise(function(resolve) {
        var cleanup = function cleanup() {
            if (!!wechatWindow && !wechatWindow.closed) {
                wechatWindow.close();
            }
            window.clearInterval(windowWatcher);
            window.removeEventListener('message', handleWechatCallback);
        };
        var wechatWindow = openWechatPopup(config.redirectUrl, config.appId);
        var handleWechatCallback = function(e) {
            var _e_data, _e_data1;
            var _ref = new URL(config.redirectUrl), targetOrigin = _ref.origin;
            if (e.origin !== targetOrigin) return;
            var source = (_e_data = e.data) == null ? void 0 : _e_data.source;
            if (source !== 'weChatCallback') return;
            cleanup();
            var code = (_e_data1 = e.data) == null ? void 0 : _e_data1.code;
            if (!!code) {
                return resolve({
                    code: code,
                    status: SocialLoginResponseStatus.Success
                });
            } else {
                return resolve({
                    status: SocialLoginResponseStatus.Error
                });
            }
        };
        var windowWatcher = 0;
        try {
            windowWatcher = window.setInterval(function() {
                if (!wechatWindow || wechatWindow.closed) {
                    cleanup();
                    return resolve({
                        status: SocialLoginResponseStatus.Error
                    });
                }
            }, 2000);
        } catch (error) {
            cleanup();
            return resolve({
                status: SocialLoginResponseStatus.Error,
                error: "" + error
            });
        }
        window.addEventListener('message', handleWechatCallback);
    });
};

export { WeChatSdkLogin };
